module.exports = __webpack_public_path__ + "img/s4-0.ff972f4e.svg";